import { hcpAPI } from 'configs/axios';

export const fetchTestVariablesById = (testId: string, signal?: AbortSignal | undefined) => {
  return hcpAPI({
    url: `/reports/variables/${testId}`,
    method: 'GET',
    config: {
      signal,
    },
  });
};

export const fetchSummaryVariables = (id: string, signal?: AbortSignal | undefined) => {
  return hcpAPI({
    url: `/reports/summary_variables/${id}`,
    method: 'GET',
    config: {
      signal,
      params: { with_images: true },
    },
  });
};

export const fetchNightlyVariables = (id: string, signal?: AbortSignal | undefined) => {
  return hcpAPI({
    url: `/reports/nightly_variables/${id}`,
    method: 'GET',
    config: {
      signal,
      params: { with_images: true },
    },
  });
};

export const fetchSummaryReport = (id: string, signal?: AbortSignal | undefined) => {
  const params = {
    query: JSON.stringify({ test: [id], approved: true, current_report: true }),
  };
  return hcpAPI({
    url: '/reports/summary',
    method: 'GET',
    config: {
      params,
      signal,
    },
  });
};

export const fetchNightlyReports = (
  ids?: string[],
  signal?: AbortSignal | undefined,
  original?: boolean
) => {
  const params = original
    ? {
        query: JSON.stringify({
          recording: ids,
          manual_edit: false,
        }),
      }
    : {
        query: JSON.stringify({
          recording: ids,
          current_report: true,
        }),
      };
  return hcpAPI({
    url: '/reports/pdf',
    method: 'GET',
    config: {
      params,
      signal,
    },
  });
};

export const fetchReportStatus = (id: string, signal?: AbortSignal | undefined) => {
  return hcpAPI({
    url: `/reports/nightly_variables/${id}`,
    method: 'GET',
    config: {
      signal,
      params: { with_images: false },
    },
  });
};

export const updatePdfReport = (
  id: string,
  data: {
    read: boolean;
  }
) => {
  return hcpAPI({ url: `/reports/pdf/${id}`, method: 'PATCH', data });
};

export const updateSummaryReport = (
  id: string,
  data: {
    read: boolean;
  }
) => {
  return hcpAPI({ url: `/reports/summary/${id}`, method: 'PATCH', data });
};

export const fetchSummaryReports = (ids?: string[], signal?: AbortSignal | undefined) => {
  const params = {
    query: JSON.stringify({
      test: ids,
      current_report: true,
    }),
  };
  return hcpAPI({
    url: '/reports/summary',
    method: 'GET',
    config: {
      params,
      signal,
    },
  });
};

export const regenerateReport = (id: string) => {
  const params = {
    test_id: id,
  };
  return hcpAPI({
    url: '/reports/regenerate_report',
    method: 'POST',
    config: {
      params,
    },
  });
};
